import React from 'react';
import { Widget } from '@sprinklr/stories/widget/Widget';
import { Theme } from 'models/Theme/Theme';
import { CollapseProps, TunablesCollapse } from 'components/Sidebar/RenderTunables/RenderTunables';
import i18n from 'i18next';
import {
    blackListTunables,
    headerTunables,
    opacityTunables,
} from 'components/Sidebar/RenderTunables/SharedTunables';
import {
    legendTunables,
    metaInfoTunables,
    metricGroupTunables,
} from 'components/Sidebar/RenderTunables/HyperspaceSharedTunables';
import ActionCheckboxSliderGroup from 'components/_UI/Forms/Actions/ActionCheckboxSliderGroup';
import ActionSliderGroup from 'components/_UI/Forms/Actions/ActionSliderGroup';
import { widgetHasDim } from 'utils/Widget/WidgetUtils';

export const HyperspaceSmartClusterWidgetTunables = (
    widget: Widget,
    mergedTheme: Theme
): TunablesCollapse[] => {
    return [
        {
            props: {
                label: i18n.t('Smart Cluster'),
                startOpen: true,
            } as CollapseProps,
            children: [
                ...headerTunables(widget),
                opacityTunables(widget),
                <ActionCheckboxSliderGroup
                    key='donutWidth'
                    label={i18n.t('Adjust Donut Width')}
                    showValue
                    checkbox={{
                        option: widget.options.donutWidth,
                        value: 'enabled',
                    }}
                    slider={{
                        option: widget.options.donutWidth,
                        value: 'size',
                        min: 5,
                        max: 100,
                    }}
                />,
            ],
        },
        metricGroupTunables(widget),
        // metaInfoTunables({ widget, color: true, image: false }),
        legendTunables(widget),
        {
            props: {
                label: i18n.t('Exclude List'),
                startOpen: false,
            } as CollapseProps,
            children: [blackListTunables(widget)],
        },
    ];
};
